/** Rutas de consola web → rutas de la PWA. */
export function pwaPathFromDeepLink(deepLinkPath: string | null | undefined): string | null {
  if (!deepLinkPath?.trim()) return null;
  const p = deepLinkPath.trim();
  const conv = /^\/app\/conversations\/([^/?#]+)/.exec(p);
  if (conv) return `/conversations/${conv[1]}`;
  if (p.startsWith('/conversations/')) return p.split('?')[0] ?? p;
  if (p === '/notifications' || p.startsWith('/notifications')) return '/notifications';
  return p.startsWith('/') ? p : `/${p}`;
}
